import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	color: ${CSSVars.gray900};
	max-width: 1200px;
	margin: 0 auto;

	padding: 50px 20px;
	color: ${CSSVars.black};

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	h2 {
		text-align: center;
		font-size: ${CSSVars.fontSize2XL};
		margin-bottom: 50px;
	}

	.rules-wrapper {
		display: flex;
		justify-content: space-between;
		width: 100%;
		gap: 30px;
		flex-direction: column;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			flex-direction: row;
			gap: 50px;
		}

		.can,
		.cant {
			h6 {
				font-size: ${CSSVars.fontSizeLG};
				margin-bottom: 20px;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					margin-bottom: 30px;
					font-size: ${CSSVars.fontSizeXL};
				}
			}

			ul {
				max-width: 540px;
				margin-bottom: 30px;
				list-style: none;

				li {
					font-size: ${CSSVars.fontSizeMD};
					font-weight: 300;
					position: relative;
					padding-left: 25px;
					margin-bottom: 10px;

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						margin-bottom: 20px;
						font-size: ${CSSVars.fontSizeLG};
					}

					&::before {
						content: '.';
						color: ${CSSVars.blue};
						font-size: 50px;
						position: absolute;
						left: 5px;
						top: -38px;
					}
				}
			}
		}

		.cant ul li::before {
			color: ${CSSVars.pink};
		}
	}

	.small {
		margin-top: 30px;

		p {
			text-align: left;
			font-size: ${CSSVars.fontSizeSM};
			font-weight: 300;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				text-align: center;
			}

			&.dark {
			}
		}
	}
`;
